import { useCallback, useEffect } from 'react';
import { ApiError } from '../types/ApiResponse';
import MarkerService from 'src/api/marker';
import { HealthMarkerConversion } from '../types/HealthMarkerReport';
import { useAnalytics } from './useAnalytics';
import { useAppStore } from '../store';
import { useIsUserLogged } from './useUser';

export const useAllMarkerConversionEffect = () => {
  const { addAnalyticsLog } = useAnalytics('useAllMarkerConversions.ts');

  const setAllMarkerConversions = useAppStore((state) => state.setAllMarkerConversions);
  const isUserLogged = useIsUserLogged();

  const loadAllMarkerConversions = useCallback(
    (promise: Promise<HealthMarkerConversion[]>) => {
      promise
        .then((markerConversions: HealthMarkerConversion[]) => {
          setAllMarkerConversions(markerConversions);
        })
        .catch((err: ApiError) => {
          addAnalyticsLog({ function: 'loadAllMarkers', data: err, logType: 'error' });
        })
        .finally(() => {});
    },
    [addAnalyticsLog, setAllMarkerConversions]
  );

  useEffect(() => {
    if (isUserLogged) {
      const { promise, abort } = MarkerService.getAllMarkerConversions();
      loadAllMarkerConversions(promise);
      return abort;
    }
  }, [isUserLogged, loadAllMarkerConversions]);

  return [];
};
